

export default (function() {
  'use strict';

  var accordions = document.querySelectorAll('.js-accordion-wrapper');
  var accordionTriggers = document.querySelectorAll('.js-accordion-trigger')

  function updateAccordionState(accordion, accordionTrigger, open) {

    let expandedIndicator = accordionTrigger.querySelector('[data-expanded]')

    if (accordion.classList.contains('open') && typeof open === 'undefined') {
      accordion.classList.remove('open')
      accordionTrigger.setAttribute('aria-expanded', 'false')
      accordionTrigger.classList.remove('open')

      if (expandedIndicator) {
        expandedIndicator.innerHTML = expandedIndicator.dataset.collapsed || '+'
      }

      return;
    }

    accordion.classList.add('open')
    accordionTrigger.setAttribute('aria-expanded', 'true')
    accordionTrigger.classList.add('open')

    if (expandedIndicator) {
      expandedIndicator.innerHTML = expandedIndicator.dataset.expanded || '+'
    }
  }

  function initAccordion() {

        accordions.forEach(function(accordion){

        var hidden = accordion.querySelector('.accordion');
        var btn = accordion.querySelector('.accordion-btn');

        if (!btn) {
          return;
        }

        // Setup for when the accordion needs to be open by default
        if (hidden.classList.contains('open')) {
          updateAccordionState(hidden, btn, true)
        }

        btn.addEventListener('click', function(e){
          e.preventDefault();

          let btn = e.currentTarget

          updateAccordionState(hidden, btn)
        })

      })

      accordionTriggers.forEach(function(accordionTrigger) {
        accordionTrigger.addEventListener('click', (e) => {

          let accordionTrigger = e.currentTarget
          let accordionTargetId = e.currentTarget.getAttribute('aria-controls')

          if (!accordionTargetId) {
            console.warn('accordion target selector not found on', e.currentTarget)
            return;
          }

          let accordionTarget = document.getElementById(accordionTargetId)

          if (!accordionTarget) {
            console.warn('accordion target not found using selector', accordionTargetSelector)
          }

          let hidden = accordionTarget.querySelector('.accordion')

          updateAccordionState(hidden, accordionTrigger)
        })
      })

  }

  function init() {
    if(accordions) {
      initAccordion();
    }
  }

  return {
    init: init
  };


  /* eslint-enable no-unused-vars */

})()
